// extracted by mini-css-extract-plugin
export var aircallIframe = "_mx-3";
export var fabContainer = "_mx-5";
export var fabRinging = "_mx-6";
export var loadingOverlay = "_mx-4";
export var pulse = "_mx-7";
export var widgetContent = "_mx-2";
export var widgetPanel = "_mx-0";
export var widgetPanelExpanded = "_mx-1";